import React from 'react';
import { ArrowRight } from 'lucide-react';
export const HeroSection = () => {
  return <section className="relative w-full bg-[#0a2351] text-white pt-20" data-id="element-167">
      <div className="absolute inset-0 z-0 opacity-20" data-id="element-168">
        <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="City skyline background" className="w-full h-full object-cover" data-id="element-169" />
      </div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32 relative z-10" data-id="element-170">
        <div className="max-w-3xl" data-id="element-171">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight animate-fade-in" data-id="element-172">
            Strategic Capital for Visionary Growth
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 max-w-2xl" data-id="element-173">
            Empowering exceptional companies with the resources and expertise to
            achieve sustainable long-term success.
          </p>
          <div className="flex flex-wrap gap-4" data-id="element-174">
            <a href="#contact" className="inline-flex items-center px-6 py-3 border-2 border-white bg-white text-[#0a2351] font-semibold rounded-md hover:bg-transparent hover:text-white transition-all duration-300" data-id="element-175">
              Get in Touch
              <ArrowRight size={18} className="ml-2" data-id="element-176" />
            </a>
            <a href="#portfolio" className="inline-flex items-center px-6 py-3 border-2 border-white text-white font-semibold rounded-md hover:bg-white hover:text-[#0a2351] transition-all duration-300" data-id="element-177">
              View Portfolio
            </a>
          </div>
        </div>
      </div>
      <div className="h-16 bg-gradient-to-b from-[#0a2351] to-white opacity-20" data-id="element-178"></div>
    </section>;
};